$(document).ready(function(){

	$(".generalmessage").prependTo(".header");
		//prepend general message into header
		if ( $("body").hasClass("generalMessageOn") ) {
			$(".generalmessage").prependTo(".header");
		}
		if ( $("body").hasClass("saffireMobileSize") ) {
			$(".footerItems2").insertAfter(".footer-right-content");
		} else {
					$(".footerItems2").insertAfter(".footer-left-content #cardWidget");
			}

			// Remove button class from footer menu
	 $( ".footerItems1 a" ).removeClass( "button" );
		 // footer logo
	 $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');
});

$(window).load(function(){
	// Weather Bug
  setInterval(function() {
    var str = $('#weatherBugDescription').text();
    var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if(!weatherBugSet && str != ''){
      $('#weatherBugWidget').addClass('weatherBugSet');
        var findSpace = str.lastIndexOf(' ');
        var stringLength = str.length;
        var res = str.substring(findSpace, stringLength);
        var start = str.substring(0, findSpace);
        $('#weatherBugDescription').html('<span class="weatherDescriptive">'+start+'</span>'+res);
        $('#weatherBugWidget').css('visibility', 'visible');
    }
  },12);
	$('body').addClass('pageIsLoaded');
	$( ".footerItems1 a" ).removeClass( "button" );
	if ($(window).width() < 801) {
			$( ".countdown-main" ).insertAfter( ".homepageSwiperSlider" );
	} else {
			$( ".countdown-main" ).appendTo( ".headerInnerContent" );
	}

});



$(window).resize(function(){
	$( ".footerItems1 a" ).removeClass( "button" );
	if ($(window).width() < 801) {
			$( ".countdown-main" ).insertAfter( ".homepageSwiperSlider" );
	} else {
			$( ".countdown-main" ).appendTo( ".headerInnerContent" );
	}
});
